import { Fragment, useMemo } from "react";
import { Sparkles } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { PHONE_DISPLAY, IG_HANDLE } from "../../lib/site";

const Diamond = () => <span className="mx-5 inline-block h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />;

export const NewsTicker = () => {
  const { settings, services } = useSite();
  const items = useMemo(() => {
    const custom = (settings.ticker_text || "").split("•").map((s) => s.trim()).filter(Boolean);
    if (custom.length) return custom;
    const camp = settings.campaign_active && settings.campaign_text ? [settings.campaign_text] : [];
    return ["Online Randevu", ...camp, ...services.map((s) => s.title), PHONE_DISPLAY, IG_HANDLE, "Merkez/Sivas"];
  }, [settings, services]);

  const row = (key) => (
    <div className="flex shrink-0 items-center" aria-hidden={key === "b"}>
      {items.map((t, i) => (
        <Fragment key={`${key}-${i}`}>
          <span className="whitespace-nowrap">{t}</span>
          <Diamond />
        </Fragment>
      ))}
    </div>
  );

  return (
    <div className="ticker relative overflow-hidden border-b border-gold/30 bg-emerald-grad text-cream" data-testid="news-ticker" aria-label="Duyurular">
      <div className="absolute inset-y-0 left-0 z-10 flex items-center gap-2 bg-gradient-to-r from-[#c5a059] to-[#dcc48e] px-3 text-[11px] font-semibold text-emerald-950 sm:px-4">
        <Sparkles className="h-3.5 w-3.5" strokeWidth={2} /> <span className="hidden sm:inline">Lunessa</span>
      </div>
      <div className="ticker-track flex w-max py-2 pl-12 text-[12.5px] font-semibold tracking-wide sm:pl-28 sm:text-[13px]">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
};
